/**
 * 运营看板 API — GET /api/dashboard。
 */
import client from "./client";
import type { DashboardData } from "../types";

/**
 * 获取运营看板聚合数据。
 * GET /api/dashboard?company_id= → {stats, account_list, product_ranking, recent_activities, delivery_overview}
 *
 * @param companyId 可选，按公司过滤统计数据（admin 跨账户筛选）。
 */
export async function getDashboard(
  companyId?: string,
): Promise<DashboardData> {
  return client.get<unknown, DashboardData>("/dashboard", {
    params: companyId ? { company_id: companyId } : undefined,
  });
}
